import config from '../config';

const geocodeCache = new Map();
const MINIMUM_LOOKUP_INTERVAL_MS = 1000;
let lastLookupStartedAt = 0;

function wait(milliseconds) {
  return new Promise((resolve) => window.setTimeout(resolve, milliseconds));
}

export async function geocodeAddress(address) {
  const normalizedAddress = String(address || '').trim();
  if (!normalizedAddress) {
    throw new Error('Enter an address before finding coordinates.');
  }

  const cacheKey = normalizedAddress.toLowerCase();
  if (geocodeCache.has(cacheKey)) {
    return geocodeCache.get(cacheKey);
  }

  const searchUrl = new URL(config.GEOCODING_SEARCH_URL, window.location.origin);
  searchUrl.searchParams.set('q', normalizedAddress);
  searchUrl.searchParams.set('format', 'jsonv2');
  searchUrl.searchParams.set('limit', '1');
  searchUrl.searchParams.set('addressdetails', '1');

  const waitTime = Math.max(0, MINIMUM_LOOKUP_INTERVAL_MS - (Date.now() - lastLookupStartedAt));
  if (waitTime) {
    await wait(waitTime);
  }
  lastLookupStartedAt = Date.now();

  const response = await fetch(searchUrl.toString(), {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    throw new Error('The address lookup service is unavailable. Enter coordinates manually.');
  }

  const matches = await response.json();
  const match = Array.isArray(matches) ? matches[0] : null;
  const latitude = Number(match?.lat);
  const longitude = Number(match?.lon);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    throw new Error('No coordinates were found for that address. Enter coordinates manually.');
  }

  const result = {
    latitude,
    longitude,
    displayName: String(match?.display_name || normalizedAddress),
  };
  geocodeCache.set(cacheKey, result);
  return result;
}
